module.exports = "<p>\n  order-detail works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/order-detail/order-detail.component.html
// module id = ./src/app/components/account/order-detail/order-detail.component.html
// module chunks = main